module.exports = __webpack_public_path__ + "img/img_guang@2x.40b95462.png";